// extracted by mini-css-extract-plugin
export var content = "_2f-3";
export var contentWrapper = "_2f-2";
export var fullWidthButton = "_2f-4";
export var heroImage = "_2f-6";
export var logo = "_2f-1";
export var logoContainer = "_2f-0";
export var panel = "_2f-5";